import {REDUCER_NAME} from './const'

export const selectOwnState = state => {
    return state[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectWhatsappMessageList = state => {
    return selectOwnState(state).whatsappMessageList;
}


// WEBPACK FOOTER //
// ./src/modules/whatsapp-messages/state/selector.js